/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection11FoiChanged, m11ReportSection11ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection11Foi, selectM11ReportSection11Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialOversightChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section11State, setAlertModalState, setStartingSection11State) => {

    let changesStates = {
        section11State: section11State
    };
    let response = await saveM11Changes(apiToken, 37, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection11Resource) {
            dispatch(m11ReportSection11ResourceChanged(response.m11ReportSection11Resource));
        }
        setStartingSection11State(JSON.parse(JSON.stringify(section11State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step037CompleteTrialOversight = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection11Foi = useSelector(selectM11ReportSection11Foi);
    const m11ReportSection11Resource = useSelector(selectM11ReportSection11Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section11State, setSection11State] = useState({
        "section117Status": "empty", "section117Xhtml": "",
        "section118Status": "empty", "section118Xhtml": "",
        "section119Status": "empty", "section119Xhtml": "",
        "section1110Status": "empty", "section1110Xhtml": "",
        "section1111Status": "empty", "section1111Xhtml": "",
        "section1112Status": "empty", "section1112Xhtml": ""
    });
    const [startingSection11State, setStartingSection11State] = useState({
        "section117Status": "empty", "section117Xhtml": "",
        "section118Status": "empty", "section118Xhtml": "",
        "section119Status": "empty", "section119Xhtml": "",
        "section1110Status": "empty", "section1110Xhtml": "",
        "section1111Status": "empty", "section1111Xhtml": "",
        "section1112Status": "empty", "section1112Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section11State, startingSection11State)),
        async saveAllChanges() {
            await saveTrialOversightChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section11State, setAlertModalState, setStartingSection11State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section117Status": "empty", "section117Xhtml": "",
                "section118Status": "empty", "section118Xhtml": "",
                "section119Status": "empty", "section119Xhtml": "",
                "section1110Status": "empty", "section1110Xhtml": "",
                "section1111Status": "empty", "section1111Xhtml": "",
                "section1112Status": "empty", "section1112Xhtml": "",
                "loaded": true
            };
            setSection11State(startingData);
            setStartingSection11State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[11]?.entry?.length) {
                let m11ReportSection011Foi = getIdFromReference(m11ReportContainerResource.section[11].entry[0]);
                if (m11ReportSection011Foi && !isNaN(m11ReportSection011Foi) &&
                    m11ReportSection011Foi !== m11ReportSection11Foi) {
                    dispatch(m11ReportSection11FoiChanged(m11ReportSection011Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection11Foi && !isNaN(m11ReportSection11Foi)) {
            loadResource(m11ReportSection11Foi, "M11ReportSection11", apiToken, dispatch);
        }
    }, [m11ReportSection11Foi]);

    useEffect(() => {
        if (m11ReportSection11Resource && Object.keys(m11ReportSection11Resource).length > 0) {
            let startingData = {
                "section117Status": "empty", "section117Xhtml": "",
                "section118Status": "empty", "section118Xhtml": "",
                "section119Status": "empty", "section119Xhtml": "",
                "section1110Status": "empty", "section1110Xhtml": "",
                "section1111Status": "empty", "section1111Xhtml": "",
                "section1112Status": "empty", "section1112Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection11Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection11Resource.section[0].section[6]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[6].text.status !== "empty") {
                    startingData.section117Status = m11ReportSection11Resource.section[0].section[6].text.status;
                    startingData.section117Xhtml = m11ReportSection11Resource.section[0].section[6].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[7]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[7].text.status !== "empty") {
                    startingData.section118Status = m11ReportSection11Resource.section[0].section[7].text.status;
                    startingData.section118Xhtml = m11ReportSection11Resource.section[0].section[7].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[8]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[8].text.status !== "empty") {
                    startingData.section119Status = m11ReportSection11Resource.section[0].section[8].text.status;
                    startingData.section119Xhtml = m11ReportSection11Resource.section[0].section[8].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[9]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[9].text.status !== "empty") {
                    startingData.section1110Status = m11ReportSection11Resource.section[0].section[9].text.status;
                    startingData.section1110Xhtml = m11ReportSection11Resource.section[0].section[9].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[10]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[10].text.status !== "empty") {
                    startingData.section1111Status = m11ReportSection11Resource.section[0].section[10].text.status;
                    startingData.section1111Xhtml = m11ReportSection11Resource.section[0].section[10].text.div;
                }
                if (m11ReportSection11Resource.section[0].section[11]?.text?.div &&
                    m11ReportSection11Resource.section[0].section[11].text.status !== "empty") {
                    startingData.section1112Status = m11ReportSection11Resource.section[0].section[11].text.status;
                    startingData.section1112Xhtml = m11ReportSection11Resource.section[0].section[11].text.div;
                }
                setSection11State(startingData);
                setStartingSection11State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection11Resource]);

    return <div>
        <h3>Complete Section 11 Trial Oversight and Other General Considerations</h3>
        {!(m11ReportSection11Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 37 (Complete Section 11 Trial Oversight and Other General Considerations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section11State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.7 Data Governance summary as needed.</h4>
                    <TextDivEntry elementName="section117Xhtml"
                        startingValue={section11State.section117Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise Section 11.8 Data Protection as needed.</h4>
                    <TextDivEntry elementName="section118Xhtml"
                        startingValue={section11State.section118Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise Section 11.9 Source Records as needed.</h4>
                    <TextDivEntry elementName="section119Xhtml"
                        startingValue={section11State.section119Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.10 Protocol Deviations summary as needed.</h4>
                    <TextDivEntry elementName="section1110Xhtml"
                        startingValue={section11State.section1110Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.11 Early Site Closure summary as needed.</h4>
                    <TextDivEntry elementName="section1111Xhtml"
                        startingValue={section11State.section1111Xhtml}
                        setResourceState={setSection11State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 11.12 Data Dissemination summary as needed.</h4>
                    <TextDivEntry elementName="section1112Xhtml"
                        startingValue={section11State.section1112Xhtml}
                        setResourceState={setSection11State} />
                </>}
            </>
        }
    </div >
});

const M11Step037CompleteTrialOversightHelperText = <div>
    <h3>Complete Section 11 Trial Oversight and Other General Considerations</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 11.7 Data Governance.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the key systems and processes for critical trial integrity, traceability and security including a summary of the approaches enabling accurate data collection, reporting, monitoring, transfer, retention, and access if not addressed in separate agreement(s).</p>
        </div>
        <p>Enter data for Section 11.8 Data Protection.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the measures to protect the privacy and confidentiality of personal information of trial participants in accordance with applicable regulatory requirements on personal data protection and any measures that should be taken in case of a data security breach.</p>
        </div>
        <p>Enter data for Section 11.9 Source Records.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>State the importance of source records and expectation for traceability.</p>
            <p>Delineate expectations for investigators (e.g., maintain and ensure availability of essential records) and trial monitors (e.g., ensure participant protections, ensure that the trial is conducted according to GCP).</p>
            <p>Identify what constitutes source records and its origin or provide a reference to the location of this information, if contained in a separate document.</p>
            <p>Describe the provision for direct access to source records enabling clinical trial-related monitoring, audits and regulatory inspections, if not included in separate agreement(s).</p>
        </div>
        <p>Enter data for Section 11.10 Protocol Deviations.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe plans for detecting, reviewing, and reporting any deviations from the protocol or include reference to a separate document.</p>
        </div>
        <p>Enter data for Section 11.11 Early Site Closure.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>List the sponsor’s rights to close a site early. Likewise, list the investigator’s rights to initiate early site closure.</p>
            <p>List the criteria for early closure of a site by the sponsor or investigator.</p>
            <p>List the responsibilities of the sponsor and investigator following early site closure (e.g., informing the ethics committee[s], and prompt notification of the participant and their transition to appropriate therapy and/or follow-up).</p>
        </div>
        <p>Enter data for Section 11.12 Data Dissemination.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe whether the clinical trial will be registered in public databases, including reporting of results, if applicable.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>
// eslint-disable-next-line no-empty-pattern
const M11Step037CompleteTrialOversightValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 37, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 37 (Complete Section 11 Trial Oversight and Other General Considerations) {validationCheckState.step37numberOfChecks} issues checked. {validationCheckState.step37numberPassed} passed. {validationCheckState.step37numberFailed} failed.</h4>
        <p>Section 11 heading is 'TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS': {validationCheckState.resultCheckSection11Heading}</p>
        <p>Section 11 TRIAL OVERSIGHT AND OTHER GENERAL CONSIDERATIONS does not have text: {validationCheckState.resultCheckSection11Text}</p>
        <p>Section 11.7 heading is 'Data Governance': {validationCheckState.resultCheckSection117Heading}</p>
        <p>Section 11.7 Data Governance has content: {validationCheckState.resultCheckSection117Content}</p>
        <p>Section 11.8 heading is 'Data Protection': {validationCheckState.resultCheckSection118Heading}</p>
        <p>Section 11.8 Data Protection has content: {validationCheckState.resultCheckSection118Content}</p>
        <p>Section 11.9 heading is 'Source Records': {validationCheckState.resultCheckSection119Heading}</p>
        <p>Section 11.9 Source Records has content: {validationCheckState.resultCheckSection119Content}</p>
        <p>Section 11.10 heading is 'Protocol Deviations': {validationCheckState.resultCheckSection1110Heading}</p>
        <p>Section 11.10 Protocol Deviations has content: {validationCheckState.resultCheckSection1110Content}</p>
        <p>Section 11.11 heading is 'Early Site Closure': {validationCheckState.resultCheckSection1111Heading}</p>
        <p>Section 11.11 Early Site Closure has content: {validationCheckState.resultCheckSection1111Content}</p>
        <p>Section 11.12 heading is 'Data Dissemination': {validationCheckState.resultCheckSection1112Heading}</p>
        <p>Section 11.12 Data Dissemination has content: {validationCheckState.resultCheckSection1112Content}</p>
    </div>}  </div>
}

export default M11Step037CompleteTrialOversight;
export { M11Step037CompleteTrialOversightHelperText, M11Step037CompleteTrialOversightValidationCheck };